module.exports = __webpack_public_path__ + "media/images/success-214070958bd6269df1e96713c7c4745d.png";